import { getAPI } from "helpers/apiHelpers";
import { isNullOrEmpty } from "helpers/generalHelpers";
import moment from "moment";
import { deleteAllData, deleteData, insertValues } from "store/idb";
import { addUserToDb } from "store/localDb";
import { addMedsHistory, getMedsHistory, getUsersList, resetMedsHistoryState, resetMedsState, setMedsHistory, setUsersListLoaded, setUserStateLoaded, updateUserState } from "store/storeValtio";

async function awaitDelete(store, key)
{
  const response = await deleteData(store, key);
}

export async function loadDataFromFirestore(email)
{
    //console.log('loadDataFromFirestore', email);

    const users = await getAPI('userPWAByEmail/' + email);
    if (users.length === 0) return false;
    const user = users[0];
    const userId = user.id;
    // update userId reference
    user.userId = userId;
    delete user.id;
    //console.log('user from email', user);

    const usersList = getUsersList();
    //console.log('usersList', usersList);

    setUsersListLoaded(false);
    setUserStateLoaded(false);
    localStorage.removeItem('currentUser');
    localStorage.setItem('currentUser', user.userId );

    if (isNullOrEmpty(user.awakeTime)) user.awakeTime = '6:00AM';
    if (isNullOrEmpty(user.bedTime)) user.bedTime = '10:00PM';

    var ulist = [];
    const emailUC = email.toUpperCase();
    usersList.forEach(u => {
      if (u.email.toUpperCase() === emailUC) ulist.push(u.userId);
    });
    //console.log('userListIds', ulist);
    ulist.forEach(id => {
      awaitDelete('users', userId);  // just in case
    })

    let response = await addUserToDb(user);
    await response;
    //console.log('loaduserdata add user', response);
    const newUserState = {
      currentUserId: user.userId,
      currentUser: user,
      loaded: true,
      authenticated: true,
    }
    updateUserState(newUserState);

    // get meds from firestore
    var url = 'loadMeds/' + userId;
    const medList = await getAPI(url);
    //console.log('Meds: ', medList.length, medList);

    // get hist from firestore
    url = 'loadHist/' + userId;
    const histList = await getAPI(url);
    //console.log('Hist: ', histList);

    // reload meds store
    await deleteAllData('medications');
    resetMedsState();

    for(let i = 0; i < medList.length; i++) {
        let med = medList[i];
        //console.log("med ", i, ": ", med);
        if (med.dateUpdated instanceof Date) med.dateUpdated = med.dateUpdated.toISOString();
        try {
            // add new med
            let response = await insertValues('medications', med)
            let result = await response;
            //console.log('loaddata insertValues result', result);
        } catch (err) {
           console.log('loaddata med insert error', err.message);
        }

        //console.log('loaddata med added', med.medicationId);
    }
    //setMedsLoaded(true);
    //setMedsLoading(false);
 
    // reload hist store
    await deleteAllData('history');
    resetMedsHistoryState();

    for(let i = 0; i < histList.length; i++) {
        let hist = histList[i];
        //console.log("hist ", i, ": ", hist);
        if (hist.dateUpdated instanceof Date) hist.dateUpdated = hist.dateUpdated.toISOString();
        if (hist.date instanceof Date) hist.date = hist.date.toISOString();

        try {
            // add new med
            await insertValues('history', hist)
            .then ((result)=>{
              //console.log('loaddata hist insertValues result', result);
              //addMedsHistory(hist);
            })
            .catch ((error)=>{
              console.log('loaddata addMedsHistory error', error);
            });
        } catch (err) {
           console.log('loaddata hist insert error', err.message);
        }

        //console.log('loaddata hist added', hist.id);
    }
    //setMedsHistoryLoaded(true);
    //setMedsHistoryLoading(false);
    return true;
}

export async function adjustDemoData() {
  // adjust the history times to recent
  const histList = getMedsHistory();
  const now = moment();
  //console.log('adjust', histList);
  var lastDay = 1000;
  histList.forEach((h) => {
    const daysAgo = now.diff(h.date, "days");
    if (daysAgo < lastDay) lastDay = daysAgo;
    //console.log('adjust', h.id, h.date, daysAgo);
  });
  //console.log('last day', lastDay);
  histList.forEach((h) => {
    const newTime = moment(h.date).add(lastDay, 'days').toISOString();
    //console.log('new time', h.date, newTime);
    h.date = newTime;
  });
  setMedsHistory(histList);

}